// extracted by mini-css-extract-plugin
export var alertIcon = "_nd-0";